import { OrganizationCode } from '@quromedical/fhir-common';
import { assertError, composeValidator } from './composer'; // Task Assignment Rules
// - Only considers organizations that are assignable to a patient as a care team
// - User is the requester of the task
// - User is member of an "Assignable" Organization that is the owner of the task
// - User is the owner of the task

const getRuleName = _ref => {
  let {
    user,
    ownerType,
    requester
  } = _ref;

  if (user === requester) {
    return 'user-is-requester';
  }

  return `owner-is-${ownerType}`;
};

const assertUserIsOwner = _ref2 => {
  let {
    user,
    owner
  } = _ref2;

  if (user === owner) {
    return undefined;
  }

  return {
    type: 'error',
    messages: ['User is not the owner of the task']
  };
};
/**
 * Organization types that are assignable to a task that may grant a user access if they are part of
 */


export const assignableOrganizationCodes = [OrganizationCode.OrganizationalTeam, OrganizationCode.HospitalDepartment];

const assertUserIsInOrganization = _ref3 => {
  let {
    owner,
    userOrganizations = []
  } = _ref3;

  if (!owner) {
    return {
      type: 'error',
      messages: ['Owner organization is not defined']
    };
  }

  const assignableOrganizations = userOrganizations.filter(org => assignableOrganizationCodes.includes(org.type)).map(org => org.id);
  const ownerInAssignableOrgs = assignableOrganizations.includes(owner);

  if (ownerInAssignableOrgs) {
    return undefined;
  }

  return {
    type: 'error',
    messages: ["Task does not belong to user's organization"]
  };
};

const taskAssertions = {
  'user-is-requester': [],
  'owner-is-practitioner': [assertUserIsOwner],
  'owner-is-organization': [assertUserIsInOrganization],
  'owner-is-none': [assertError('Task owner not found')]
};
/**
 * a function that takes in a set of parameters and based on that determines if a consumer can do a task request for the patient
 */

export const validateTaskAssignment = composeValidator({
  getRuleName,
  assertions: taskAssertions,
  defaultAssertions: [assertError('User is not assigned to task')]
});
//# sourceMappingURL=task.js.map